import { Grid } from "@mui/material";
import React from "react";
import "../assets/styles/counter.css";
import CountUp from "react-countup";

const counterData = [
  { name: "Pieces of training as a react developer.", count: "02" },
  { name: "Joining online React Bootcamp", count: "05" },
  { name: "Own Projects", count: "10" },
];
const Counter = () => {
  return (
    <div className="counter_container">
      <Grid container>
        <Grid item xs={12} md={1}></Grid>
        <Grid item xs={12} md={10}>
          <div className="counter_content">
            {counterData.map((item, index) => {
              return (
                <div className="counter_item" key={index}>
                  <div className="counter_bg trainig_as_a_react_dev">
                    {/* <p>05</p> */}
                    <CountUp enableScrollSpy={true} start={0} end={item.count}>
                      {({ countUpRef, start }) => {
                        return (
                          <div>
                            <p className="count_up" ref={countUpRef} />
                          </div>
                        );
                      }}
                    </CountUp>
                  </div>
                  <p className="counter_name">{item.name}</p>
                </div>
              );
            })}
          </div>
        </Grid>

        <Grid item xs={12} md={1}></Grid>
      </Grid>
    </div>
  );
};

export default Counter;
